import React from "react";
import Modal, { modalStyles as m } from "./Modal";

// Android showConfirmationDialog(message, onOk, onCancel): a yes/no question where BOTH answers
// continue the flow (e.g. "Sell Custom Item As Food Stampable" — OK = EBT, Cancel = not EBT).
export default function ConfirmModal({ title = "Confirm", message, okLabel = "OK", cancelLabel = "Cancel", onOk, onCancel, onClose }) {
  return (
    <Modal title={title} onClose={onClose || onCancel}>
      <div style={{ fontSize: 15, fontWeight: 500, lineHeight: 1.4 }}>{message}</div>
      <button style={m.primary} onClick={onOk}>{okLabel}</button>
      <button style={m.ghost} onClick={onCancel}>{cancelLabel}</button>
    </Modal>
  );
}
